import axios from "axios";
import { getConfig } from "../configure";

let apiClientFront = null;
let apiClientPromiseFront = null;

let apiClientBack = null;
let apiClientPromiseBack = null;

let clientURLFront = null;
let clientPromiseURLFront = null;

// Devuelve ya un objeto axios para el Front:
export const getApiClientFront = () => {
    if (apiClientFront) {
        // Ya existe la instancia del cliente, devolverla directamente
        return Promise.resolve(apiClientFront);
    }
    if (apiClientPromiseFront) {
        // Ya está en proceso de creación, devolver la promesa pendiente
        return apiClientPromiseFront;
    }

    // Crear la promesa que resolverá el cliente Axios cuando la configuración esté lista
    apiClientPromiseFront = new Promise((resolve, reject) => {
        const tryCreateClient = () => {
        try {
            const config = getConfig(); // lanza error si no está lista
            apiClientFront = axios.create({
            baseURL: config.apiUrlFront,
            });
            resolve(apiClientFront);
        } catch (err) {
            // Si no está lista, reintentar después de un breve delay
            setTimeout(tryCreateClient, 50);
        }
        };
        tryCreateClient();
    });

    return apiClientPromiseFront;
};

// Devuelve ya un objeto axios para el Back:
export const getApiClientBack = () => {
    if (apiClientBack) {
        // Ya existe la instancia del cliente, devolverla directamente
        return Promise.resolve(apiClientBack);
    }
    if (apiClientPromiseBack) {
        // Ya está en proceso de creación, devolver la promesa pendiente
        return apiClientPromiseBack;
    }

    // Crear la promesa que resolverá el cliente Axios cuando la configuración esté lista
    apiClientPromiseBack = new Promise((resolve, reject) => {
        const tryCreateClient = () => {
        try {
            const config = getConfig(); // lanza error si no está lista
            apiClientBack = axios.create({
            baseURL: config.apiUrlBack,
            });
            resolve(apiClientBack);
        } catch (err) {
            // Si no está lista, reintentar después de un breve delay
            setTimeout(tryCreateClient, 50);
        }
        };
        tryCreateClient();
    });

    return apiClientPromiseBack;
};

// Devuelve texto con la URL del Front:
export const getURLFront = () => {
    if (clientURLFront) {
        // Ya existe la instancia del cliente, devolverla directamente
        return Promise.resolve(clientURLFront);
    }
    if (clientPromiseURLFront) {
        // Ya está en proceso de creación, devolver la promesa pendiente
        return clientPromiseURLFront;
    }

    // Crear la promesa que resolverá cuando la configuración esté lista
    clientPromiseURLFront = new Promise((resolve, reject) => {
        const tryCreateClient = () => {
        try {
            const config = getConfig(); // lanza error si no está lista            
            const clientURLFront= config.apiUrlFront;            
            resolve(clientURLFront);
        } catch (err) {
            // Si no está lista, reintentar después de un breve delay
            setTimeout(tryCreateClient, 50);
        }
        };
        tryCreateClient();
    });

    return clientPromiseURLFront;
};